import { useCallback, useState } from "react";
import type { LayoutChangeEvent } from "react-native";
import {
	useAnimatedReaction,
	useAnimatedScrollHandler,
	useSharedValue,
} from "react-native-reanimated";
import { scheduleOnRN } from "react-native-worklets";

export const useAnimatedHeaderScroll = () => {
	const scrollY = useSharedValue(0);
	const [headerHeight, setHeaderHeight] = useState(0);
	const [heroHeight, setHeroHeight] = useState(0);
	const [titleScrollThreshold, setTitleScrollThreshold] = useState(0);
	const [isHeaderSolid, setIsHeaderSolid] = useState(false);

	const onHeaderLayout = useCallback((e: LayoutChangeEvent) => {
		setHeaderHeight(e.nativeEvent.layout.height);
	}, []);

	const onHeroLayout = useCallback((e: LayoutChangeEvent) => {
		setHeroHeight(e.nativeEvent.layout.height);
	}, []);

	const onTitleTextLayout = useCallback((e: LayoutChangeEvent) => {
		setTitleScrollThreshold(e.nativeEvent.layout.height);
	}, []);

	const updateHeaderSolid = useCallback((next: boolean) => {
		setIsHeaderSolid(next);
	}, []);

	useAnimatedReaction(
		() => scrollY.value > titleScrollThreshold,
		(isSolid, prev) => {
			if (isSolid !== prev) {
				scheduleOnRN(updateHeaderSolid, isSolid);
			}
		},
		[updateHeaderSolid, titleScrollThreshold],
	);

	const scrollHandler = useAnimatedScrollHandler({
		onScroll: (event) => {
			scrollY.value = event.contentOffset.y;
		},
	});

	return {
		scrollY,
		scrollHandler,
		headerHeight,
		heroHeight,
		titleScrollThreshold,
		isHeaderSolid,
		onHeaderLayout,
		onHeroLayout,
		onTitleTextLayout,
	};
};
